import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { from, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AuthService } from '../../auth/auth.service';
import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../common/take-until-destroy.decorator';

import { TranslationKeyMap } from './auth.i18n';
import { AuthService as TeamsCallService } from './auth.service';

@Component({
    selector: 'cmps-teamscall-auth',
    templateUrl: './auth.component.html',
})
@TakeUntilDestroy()
export class AuthComponent implements OnInit, OnDestroy {
    @Input() showLogin: boolean;
    @Output() hasValidTokenChange: EventEmitter<boolean>;

    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */ _hasValidToken: boolean | null;

    /** @private */ _didFirstAttempt: boolean | null;

    get hasValidToken(): boolean | null {
        return this._hasValidToken;
    }

    constructor(
        private readonly _authService: AuthService,
        /** @private */ readonly _service: TeamsCallService,
    ) {
        this.showLogin = true;
        this.hasValidTokenChange = new EventEmitter();
    }

    ngOnInit(): void {
        this._service.tokenChange
            .pipe(
                catchError(() => {
                    return of(null);
                }),
                tap((token) => {
                    this._didFirstAttempt = true;
                    this._hasValidToken = token != null;
                    this.hasValidTokenChange.emit(this._hasValidToken);
                }),
                takeUntilDestroy(this),
            )
            .subscribe();

        this._run();
    }

    ngOnDestroy(): void {
        this.hasValidTokenChange.complete();
    }

    /** @private */
    _onSignInClick(): void {
        this._run();
    }

    private _run(): void {
        from(this._service.getToken(this._authService.user.id))
            .pipe(
                catchError(() => {
                    return of(null);
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
